import { PsvReviewStatus } from "@api/shared-runtime/psv-review";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import {
  decisionAttribution,
  STAFF_STATUS_LABEL,
} from "@/features/credentials/components/primary-source-runs/run-report-dialog/item-status";
import type { ReportItem } from "@/features/credentials/components/primary-source-runs/types";

const AWAITING_RESULTS = "Awaiting results";
const AWAITING_REVIEW = "Awaiting review";
const TOOLTIP_DELAY_MS = 300;

const DECIDED_STYLE: Partial<Record<PsvReviewStatus, string>> = {
  [PsvReviewStatus.Accepted]: "text-green-700",
  [PsvReviewStatus.Concern]: "font-medium text-red-700",
  [PsvReviewStatus.InReview]: "text-blue-700",
};

/** Who settled the item, or what it is waiting on. */
export function VerifiedBy({
  decision,
  id,
}: {
  decision: ReportItem["decision"];
  id: string;
}) {
  if (!decision) {
    return (
      <span id={id} className="text-xs text-muted-foreground">
        {AWAITING_RESULTS}
      </span>
    );
  }
  if (decision.status === PsvReviewStatus.Pending) {
    return (
      <span id={id} className="text-xs text-muted-foreground">
        {AWAITING_REVIEW}
      </span>
    );
  }
  const label = STAFF_STATUS_LABEL[decision.status];
  const decided = decision.status !== PsvReviewStatus.InReview;
  const name = decided ? decision.decidedBy?.name : null;
  const text = name ? `${label} · ${name}` : label;
  return (
    <TooltipProvider delayDuration={TOOLTIP_DELAY_MS}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            id={id}
            className={cn("text-xs", DECIDED_STYLE[decision.status])}
          >
            {text}
          </span>
        </TooltipTrigger>
        {decided && (
          <TooltipContent className="text-xs">
            {decisionAttribution(decision)}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
